import React from "react";
import img2 from "../imgs/img2.png";
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import discord from "../imgs/img18.svg";
import x from "../imgs/img19.svg";
import telegram from "../imgs/img20.svg";

export default function Footer() {
  return (
    <div className="w-full bg-[#313131] text-white flex flex-col rounded-t-[15px] items-center mt-[5%] pb-6">
      <img
        src={img2}
        alt="Top Image"
        className="w-[50%] object-contain z-10 max-w-[300px] sm:max-w-[350px]"
      />

      <div className="text-[12px] font-bold mt-[-4px] text-center px-4">
        OTAKU<span className="text-[#FF9500]">’S-</span> Watch free anime and manga online in HD
      </div>

      {/* Social media icons */}
      <div className="flex flex-row gap-4 mt-4">
        <FacebookRoundedIcon style={{ fontSize: 30, color: '#FF9500' }} />
        <img src={discord} alt="discord" className="w-[33px] h-[33px]" />
        <img src={x} alt="x" className="w-[33px] h-[33px]" />
        <img src={telegram} alt="telegram" className="w-[33px] h-[33px]" />
      </div>
    </div>
  );
}
